import $ from "jquery";

$(document).ready(function () {
  const $container = $("#quadrantContainer");
  const $images = $container.find(".quad-image");
  
  // Quadrants in the order you want them to cycle through:
  // "top-left" => quadrant-content1
  // "top-right" => quadrant-content2
  // "bottom-left" => quadrant-content3
  // "bottom-right" => quadrant-content4
  const quadrantSequence = ["top-left", "top-right", "bottom-left", "bottom-right"];
  
  // Start on quadrant index 0 (which corresponds to "top-left" => quadrant-content1)
  let currentQuadrantIndex = 0;
  
  /**
   * setActiveQuadrant handles:
   *  1. Activating the new quadrant image
   *  2. Fading in the corresponding content (.image_interactive_content)
   *  3. Fading out the old content
   */
  function setActiveQuadrant(quadrantClass) {
    // 2. Activate the new image
    $images.removeClass("active");
    const $newImage = $container.find(`.quad-image.${quadrantClass}`).addClass("active");

    // 3. Get the data-content from the newly active image
    const dataContent = $newImage.data("content");

    // 4. Identify old vs. new content blocks
    const $oldContent = $(".image_interactive_content.active, .image_interactive_content.active-absolute");
    const $newContent = $(`.${dataContent}`);

    // If the new content is the same as the old content, do nothing
    if ($oldContent.length && $oldContent[0] === $newContent[0]) {
      return;
    }

    // PHASE A: Put new content on top as absolute so it can fade in.
    $newContent
      .removeClass("fade-out")      // remove any leftover fade-out
      .removeClass("active")        // remove "active" in case it had it
      .addClass("active-absolute"); // => position: absolute; opacity: 1

    // The old content remains .active (position: relative) until we fade it out.

    // PHASE B: After new content is (partially) faded in, fade out old content
    // Adjust setTimeout values (200ms, 300ms, 500ms, etc.) to match your CSS durations/delays
    setTimeout(() => {
      // fade out the old content
      $oldContent
        .removeClass("active active-absolute") // remove old 'active' states
        .addClass("fade-out");                 // => position: absolute; fade out

      // Once the old content is done fading out, remove fade-out and finalize new content
      setTimeout(() => {
        // old content is fully faded out now
        $oldContent.removeClass("fade-out");

        // switch new content from absolute to relative
        $newContent.removeClass("active-absolute").addClass("active");
      }, 200); // e.g., if your fade-out is 0.3s, plus any delay; adjust as needed
    }, 200);   // e.g., wait 0.2s or 0.5s for new content to fade in first
  }

  // 1) If the container is clicked, figure out which quadrant was clicked
  $container.on("click", function (e) {
    const rect = this.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const midX = rect.width / 2;
    const midY = rect.height / 2;
    let quadrant = "";

    if (y < midY) {
      quadrant = x < midX ? "top-left" : "top-right";
    } else {
      quadrant = x < midX ? "bottom-left" : "bottom-right";
    }

    // Also update currentQuadrantIndex to match the one just clicked
    // (so the "Next" button continues from here)
    currentQuadrantIndex = quadrantSequence.indexOf(quadrant);
    if (currentQuadrantIndex < 0) currentQuadrantIndex = 0; // fallback

    // Run the fade logic
    setActiveQuadrant(quadrant);
  });

  // 2) If the Next Approach button is clicked, go to the next quadrant
  $(".image_interactive_content .btn-8").on("click", function (e) {
    e.preventDefault(); // prevent any anchor navigation if needed

    // increment index, wrap around at 4 (the length of quadrantSequence)
    currentQuadrantIndex = (currentQuadrantIndex + 1) % quadrantSequence.length;

    // find the next quadrant name
    const nextQuadrant = quadrantSequence[currentQuadrantIndex];
    // apply the fade logic
    setActiveQuadrant(nextQuadrant);
  });
});
